<template>
  <div>
    <StackedSegments
      :question="question"
      :order="order"
      :colors="colors"
      :default-order="defaultOrder"
      class="mb-16"
      @changeSegment="segment = $event"
    />

    <div class="mb-2">
      <ButtonPlus
        class="mb-4"
        :status="!showSubquestion1"
        @click="showSubquestion1 = !showSubquestion1"
        >¿Por qué motivos cree que el riesgo es alto o muy alto?</ButtonPlus
      >
      <div v-show="showSubquestion1" class="mb-10">
        <div class="mb-6">
          <SegmentSelector v-model="segment" />
        </div>
        <HorizontalBarChart bar-class="bg-c2" :data="barData1" />
      </div>
    </div>

    <div>
      <ButtonPlus
        class="mb-4"
        button-class="bg-c4 group-hover:bg-c5"
        :status="!showSubquestion2"
        @click="showSubquestion2 = !showSubquestion2"
        >¿Por qué motivos cree que el riesgo es bajo o muy bajo?</ButtonPlus
      >
      <div v-show="showSubquestion2">
        <div class="mb-6">
          <SegmentSelector v-model="segment" />
        </div>
        <HorizontalBarChart bar-class="bg-c4" :data="barData2" />
      </div>
    </div>
  </div>
</template>

<script>
import StackedSegments from "@/views/StackedSegments";
import HorizontalBarChart from "@/components/HorizontalBarChart";
import ButtonPlus from "@/components/ButtonPlus";
import SegmentSelector from "@/components/SegmentSelector";
import data from "@/assets/data/data";
import IDS from "@/utils/ids";
import { segments } from "@/utils/helpers";

export default {
  components: {
    StackedSegments,
    HorizontalBarChart,
    ButtonPlus,
    SegmentSelector,
  },
  props: {
    question: {
      type: Number,
      required: true,
    },
    order: {
      type: Object,
      required: true,
    },
    colors: {
      type: Object,
      required: true,
    },
    defaultOrder: {
      type: String,
      default: "Muy bueno",
    },
  },
  data() {
    return {
      data: data[this.question].filter((e) => e[IDS.QUESTION_SUBNUMBER] === ""),

      subquestion1: data[this.question].filter(
        (e) => e[IDS.QUESTION_SUBNUMBER] === "a"
      ),
      subquestion2: data[this.question].filter(
        (e) => e[IDS.QUESTION_SUBNUMBER] === "b"
      ),
      segments,
      segment: "TOTAL",
      showSubquestion1: false,
      showSubquestion2: false,
    };
  },
  computed: {
    barData1() {
      return this.subquestion1
        .map((e) => ({
          name: e[IDS.ANSWER],
          value: e[IDS[this.segment]],
          compare: null,
        }))
        .sort((a, b) => b.value - a.value);
    },
    barData2() {
      return this.subquestion2
        .map((e) => ({
          name: e[IDS.ANSWER],
          value: e[IDS[this.segment]],
          compare: null,
        }))
        .sort((a, b) => b.value - a.value);
    },
  },
};
</script>
